const STORAGE_KEY = 'cookieConsent';

export const getConsentPreferences = () => {
  if (typeof window === 'undefined') return null;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const hasConsented = () => {
  return getConsentPreferences() !== null;
};

const buildGtagConsent = preferences => ({
  analytics_storage: preferences.analytics ? 'granted' : 'denied',
  ad_storage: preferences.marketing ? 'granted' : 'denied',
  ad_user_data: preferences.marketing ? 'granted' : 'denied',
  ad_personalization: preferences.personalization ? 'granted' : 'denied',
  personalization_storage: preferences.personalization ? 'granted' : 'denied',
  functionality_storage: 'granted',
  security_storage: 'granted',
});

export const updateGtagConsent = preferences => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', buildGtagConsent(preferences));
};

export const saveConsentPreferences = preferences => {
  if (typeof window === 'undefined') return;
  const consent = { ...preferences, necessary: true };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  } catch {}
  updateGtagConsent(consent);
};

/**
 * Call this BEFORE gtag('config', ...) to set consent defaults.
 * If the user has already saved preferences, those values are used as defaults
 * so that analytics fires immediately on subsequent page loads.
 */
export const getDefaultConsentParams = () => {
  const saved = getConsentPreferences();
  if (saved) {
    return buildGtagConsent(saved);
  }
  return {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    personalization_storage: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
    wait_for_update: 500,
  };
};

export const acceptAll = () => {
  saveConsentPreferences({ necessary: true, analytics: true, personalization: true, marketing: true });
};

export const denyNonEssential = () => {
  saveConsentPreferences({ necessary: true, analytics: false, personalization: false, marketing: false });
};
